export default __webpack_public_path__ + "static/media/UploadIcon.9b185b7b.svg";